import pumpAlarm from "../imgs/pump_alarm_indication.svg";
import pumpOff from "../imgs/pump_off_indication.svg";
import pumpOn from "../imgs/pump_on_indication.svg";
import React, { ReactElement, useEffect } from "react";
import { SvgRefStore } from "../../../helpers/svg";
import { PumpStateStatuses } from "../Vis";
import AlarmPopup from "./AlarmPopup";
import oc from "open-color";
import { MdOutlineWifiOff } from "react-icons/md";
import SVGInsert from "../../../components/SVGInsert";
import { getBaseVisUrl } from "../../../helpers/init";
import t from "../../../helpers/i18n";

export interface CurrentAlarmInfo {
  label: string;
  value?: string;
  isCritical: boolean;
}

export default function PumpIndicator({
  alarm,
  pumpState,
  refs,
  pumpIndicationSetup,
}: {
  alarm?: CurrentAlarmInfo;
  pumpState: PumpStateStatuses;
  refs: SvgRefStore;
  pumpIndicationSetup: () => void;
}): ReactElement {
  let indicationImg = pumpOff;
  if (pumpState.hasAlarm) {
    indicationImg = pumpAlarm;
  } else if (pumpState.isOn) {
    indicationImg = pumpOn;
  }

  useEffect(() => {
    pumpIndicationSetup();
  }, []);

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "15px",
        minHeight: "80px",
        display: "flex",
      }}
    >
      {alarm && <AlarmPopup {...alarm} />}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "0 auto",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!pumpState.hasConnection ? (
          <div style={{ color: oc.red[6] }}>
            <MdOutlineWifiOff size={20} style={{ marginRight: "5px" }} /> No connection
          </div>
        ) : (
          <>
            {pumpState.isOn && (
              <div className="d-flex" style={{ marginBottom: "5px" }}>
                <div style={{ color: oc.green[7], marginRight: "5px" }}>
                  {t("Running", "Запущено")}
                </div>
              </div>
            )}

            <div style={{ width: "100%", maxWidth: "200px" }}>
              <SVGInsert
                svgPath={`${getBaseVisUrl()}/${indicationImg}`}
                svgRefStore={refs}
                lookupRefs={{
                  pumpStroke: "[oid=state-stroke]",
                  pumpText: "[oid=state-text]",
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
